import React from 'react';
import { Lock } from 'lucide-react';
import { useSettingsModal } from '../../contexts/SettingsModalContext';
import { Button } from './Button';

interface FreeTierLockProps {
  title: string;
  description: string;
  variant?: 'overlay' | 'card';
}

export const FreeTierLock: React.FC<FreeTierLockProps> = ({
  title,
  description,
  variant = 'overlay'
}) => {
  const { openSettings } = useSettingsModal();

  if (variant === 'card') {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-6 bg-neutral-50 rounded-xl border border-dashed border-neutral-300">
        <div className="w-16 h-16 rounded-full bg-neutral-100 flex items-center justify-center mb-4">
          <Lock className="w-8 h-8 text-neutral-600" />
        </div>
        <h3 className="text-lg font-semibold text-primary-900 mb-2">{title}</h3>
        <p className="text-sm text-neutral-600 text-center max-w-md mb-6 leading-relaxed">
          {description}
        </p>
        <Button onClick={() => openSettings('billing')}>
          View Plans
        </Button>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 bg-neutral-100/80 backdrop-blur-sm z-10 flex items-center justify-center">
      <div className="text-center p-6 max-w-sm">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-neutral-100 flex items-center justify-center">
          <Lock className="w-6 h-6 text-neutral-600" />
        </div>
        <h3 className="text-lg font-semibold text-primary-900 mb-2">{title}</h3>
        <p className="text-sm text-neutral-600 mb-4">{description}</p>
        <Button onClick={() => openSettings('billing')}>
          View Plans
        </Button>
      </div>
    </div>
  );
};
